export interface IconInfo {
  name: string
  labelVi: string
  category: 'action' | 'status' | 'document' | 'system'
  keywords: string
}

export const CATEGORY_LABELS: Record<string, string> = {
  all: 'Tất cả',
  action: 'Thao tác',
  status: 'Trạng thái',
  document: 'Tài liệu',
  system: 'Hệ thống',
}

export const SYSTEM_ICON_LIST: IconInfo[] = [
  // Thao tác (action)
  {
    name: 'EditOutlined',
    labelVi: 'Chỉnh sửa',
    category: 'action',
    keywords: 'sua edit pencil cap nhat',
  },
  {
    name: 'DeleteOutlined',
    labelVi: 'Xóa',
    category: 'action',
    keywords: 'xoa delete trash remove thung rac',
  },
  {
    name: 'LockOutlined',
    labelVi: 'Khóa',
    category: 'action',
    keywords: 'khoa lock bao mat',
  },
  {
    name: 'UnlockOutlined',
    labelVi: 'Mở khóa',
    category: 'action',
    keywords: 'mo khoa unlock',
  },
  {
    name: 'KeyOutlined',
    labelVi: 'Chìa khóa / Mật khẩu',
    category: 'action',
    keywords: 'chia khoa key mat khau password',
  },
  {
    name: 'LogOutOutlined',
    labelVi: 'Đăng xuất',
    category: 'action',
    keywords: 'dang xuat logout thoat',
  },
  {
    name: 'LoginOutlined',
    labelVi: 'Đăng nhập',
    category: 'action',
    keywords: 'dang nhap login',
  },
  {
    name: 'PlusOutlined',
    labelVi: 'Thêm mới',
    category: 'action',
    keywords: 'them plus add tao',
  },
  {
    name: 'SaveOutlined',
    labelVi: 'Lưu',
    category: 'action',
    keywords: 'luu save',
  },
  {
    name: 'DownloadOutlined',
    labelVi: 'Tải xuống',
    category: 'action',
    keywords: 'tai download xuat',
  },
  {
    name: 'UploadOutlined',
    labelVi: 'Tải lên',
    category: 'action',
    keywords: 'upload nhap',
  },
  {
    name: 'SyncOutlined',
    labelVi: 'Đồng bộ / Làm mới',
    category: 'action',
    keywords: 'dong bo lam moi sync refresh reload',
  },
  {
    name: 'SearchOutlined',
    labelVi: 'Tìm kiếm',
    category: 'action',
    keywords: 'tim search tra cuu',
  },
  {
    name: 'UndoOutlined',
    labelVi: 'Hoàn tác / Đặt lại',
    category: 'action',
    keywords: 'undo dat lai reset quay lai',
  },
  {
    name: 'EyeOutlined',
    labelVi: 'Xem chi tiết',
    category: 'action',
    keywords: 'xem view eye chi tiet',
  },
  {
    name: 'EyeInvisibleOutlined',
    labelVi: 'Ẩn',
    category: 'action',
    keywords: 'an hide',
  },
  {
    name: 'SendOutlined',
    labelVi: 'Gửi / Chuyển',
    category: 'action',
    keywords: 'gui send chuyen',
  },
  {
    name: 'PrinterOutlined',
    labelVi: 'In ấn',
    category: 'action',
    keywords: 'in print',
  },
  {
    name: 'CopyOutlined',
    labelVi: 'Sao chép',
    category: 'action',
    keywords: 'copy sao chep',
  },
  {
    name: 'ShareAltOutlined',
    labelVi: 'Chia sẻ',
    category: 'action',
    keywords: 'share chia se',
  },

  // Trạng thái (status)
  {
    name: 'CheckCircleOutlined',
    labelVi: 'Hoạt động / Hoàn thành',
    category: 'status',
    keywords: 'thanh cong hoat dong active check success ok',
  },
  {
    name: 'CloseCircleOutlined',
    labelVi: 'Đã hủy / Vô hiệu',
    category: 'status',
    keywords: 'huy that bai close fail error cancel inactive',
  },
  {
    name: 'ClockCircleOutlined',
    labelVi: 'Chờ duyệt / Đang chờ',
    category: 'status',
    keywords: 'cho pending clock waiting thoi gian',
  },
  {
    name: 'ExclamationCircleOutlined',
    labelVi: 'Cảnh báo',
    category: 'status',
    keywords: 'canh bao warning alert chu y',
  },
  {
    name: 'InfoCircleOutlined',
    labelVi: 'Thông tin',
    category: 'status',
    keywords: 'thong tin info tro giup',
  },
  {
    name: 'PauseCircleOutlined',
    labelVi: 'Tạm dừng',
    category: 'status',
    keywords: 'tam dung pause stop',
  },
  {
    name: 'StopOutlined',
    labelVi: 'Ngừng hoạt động',
    category: 'status',
    keywords: 'ngung stop',
  },
  {
    name: 'StarOutlined',
    labelVi: 'Đặc biệt / Ưu tiên',
    category: 'status',
    keywords: 'sao star uu tien',
  },
  {
    name: 'CheckOutlined',
    labelVi: 'Đã duyệt / Xác nhận',
    category: 'status',
    keywords: 'tich check',
  },
  {
    name: 'TagOutlined',
    labelVi: 'Thẻ / Phân loại',
    category: 'status',
    keywords: 'tag nhan',
  },

  // Tài liệu & Hồ sơ (document)
  {
    name: 'FileTextOutlined',
    labelVi: 'Văn bản / Tài liệu',
    category: 'document',
    keywords: 'tai lieu van ban file text doc',
  },
  {
    name: 'FilePdfOutlined',
    labelVi: 'Tài liệu PDF',
    category: 'document',
    keywords: 'pdf file',
  },
  {
    name: 'FileExcelOutlined',
    labelVi: 'Bảng tính Excel',
    category: 'document',
    keywords: 'excel sheet bang',
  },
  {
    name: 'FileWordOutlined',
    labelVi: 'Văn bản Word',
    category: 'document',
    keywords: 'word doc',
  },
  {
    name: 'FileSignatureOutlined',
    labelVi: 'Ký số / Trình ký',
    category: 'document',
    keywords: 'ky sign signature trinh ky',
  },
  {
    name: 'FolderOutlined',
    labelVi: 'Thư mục / Hồ sơ',
    category: 'document',
    keywords: 'thu muc folder ho so',
  },
  {
    name: 'FolderOpenOutlined',
    labelVi: 'Mở thư mục',
    category: 'document',
    keywords: 'mo thu muc open folder',
  },
  {
    name: 'QrcodeOutlined',
    labelVi: 'Mã QR',
    category: 'document',
    keywords: 'qr qrcode',
  },
  {
    name: 'BarcodeOutlined',
    labelVi: 'Mã vạch',
    category: 'document',
    keywords: 'barcode ma vach',
  },
  {
    name: 'AuditOutlined',
    labelVi: 'Thẩm tra / Kiểm tra',
    category: 'document',
    keywords: 'kiem toan audit tra cuu',
  },

  // Hệ thống & Người dùng (system)
  {
    name: 'UserOutlined',
    labelVi: 'Người dùng / Cá nhân',
    category: 'system',
    keywords: 'nguoi dung user tai khoan',
  },
  {
    name: 'TeamOutlined',
    labelVi: 'Phòng ban / Nhóm',
    category: 'system',
    keywords: 'phong ban team nhom group',
  },
  {
    name: 'SettingOutlined',
    labelVi: 'Cài đặt / Thiết lập',
    category: 'system',
    keywords: 'cai dat settings thiet lap cau hinh',
  },
  {
    name: 'ToolOutlined',
    labelVi: 'Công cụ hệ thống',
    category: 'system',
    keywords: 'cong cu tool',
  },
  {
    name: 'DatabaseOutlined',
    labelVi: 'Cơ sở dữ liệu',
    category: 'system',
    keywords: 'database du lieu',
  },
  {
    name: 'BranchesOutlined',
    labelVi: 'Quy trình / Luồng',
    category: 'system',
    keywords: 'luong flow quy trinh branch',
  },
  {
    name: 'SafetyOutlined',
    labelVi: 'Bảo mật / An toàn',
    category: 'system',
    keywords: 'bao mat security an toan',
  },
  {
    name: 'BellOutlined',
    labelVi: 'Thông báo',
    category: 'system',
    keywords: 'thong bao bell chuong',
  },
  {
    name: 'CalendarOutlined',
    labelVi: 'Lịch / Ngày tháng',
    category: 'system',
    keywords: 'lich calendar ngay',
  },
  {
    name: 'MailOutlined',
    labelVi: 'Hộp thư / Email',
    category: 'system',
    keywords: 'thu email mail',
  },
]

export const ICON_MAP_BY_NAME = new Map<string, IconInfo>(
  SYSTEM_ICON_LIST.map((item) => [item.name, item])
)

/**
 * Lấy nhãn tiếng Việt ngắn gọn của icon để hiển thị trên UI
 */
export const getIconLabelVi = (iconName?: string | null): string => {
  if (!iconName) return ''
  const trimmed = iconName.trim()
  const found = ICON_MAP_BY_NAME.get(trimmed)
  if (found) return found.labelVi
  return trimmed.replace(/(Outlined|Filled)$/, '')
}

/**
 * Gợi ý icon mặc định cho mã key của SystemKey nếu DB chưa cấu hình icon
 */
export const suggestDefaultSystemKeyIcon = (codeKey?: string | null): string | null => {
  if (!codeKey || typeof codeKey !== 'string') return null
  const upper = codeKey.toUpperCase()

  if (
    upper.includes('ACTIVE') ||
    upper.includes('SUCCESS') ||
    upper.includes('APPROVE') ||
    upper.includes('DONE')
  ) {
    return 'CheckCircleOutlined'
  }
  if (upper.includes('UNLOCK')) {
    return 'UnlockOutlined'
  }
  if (upper.includes('VIEW') || upper.includes('DETAIL')) {
    return 'EyeOutlined'
  }
  if (upper.includes('LOCKED') || upper.includes('LOCK') || upper.includes('BLOCK')) {
    return 'LockOutlined'
  }
  if (upper.includes('PENDING') || upper.includes('WAIT')) {
    return 'ClockCircleOutlined'
  }
  if (
    upper.includes('CANCEL') ||
    upper.includes('REJECT') ||
    upper.includes('FAIL') ||
    upper.includes('INACTIVE')
  ) {
    return 'CloseCircleOutlined'
  }
  if (upper.includes('LOGOUT')) {
    return 'LogOutOutlined'
  }
  if (upper.includes('LOGIN')) {
    return 'LoginOutlined'
  }
  if (upper.includes('PASSWORD') || upper.includes('FORGOT') || upper.includes('KEY')) {
    return 'KeyOutlined'
  }
  if (upper.includes('EDIT') || upper.includes('UPDATE')) {
    return 'EditOutlined'
  }
  if (upper.includes('DELETE') || upper.includes('REMOVE')) {
    return 'DeleteOutlined'
  }
  if (upper.includes('SIGN')) {
    return 'FileSignatureOutlined'
  }
  if (upper.includes('DOC') || upper.includes('FILE')) {
    return 'FileTextOutlined'
  }
  if (upper.includes('USER') || upper.includes('ACCOUNT')) {
    return 'UserOutlined'
  }
  if (upper.includes('DEPT') || upper.includes('DEPARTMENT')) {
    return 'TeamOutlined'
  }
  return null
}
